// extracted by mini-css-extract-plugin
export default {"h6":"text_h6__DbhCy","h5":"text_h5__18Hx+","h4":"text_h4__VNS65","h3":"text_h3__qGRtS","h2":"text_h2__OSE1D","h1":"text_h1__7s0fV","p":"text_p__NL9np","span":"text_span__Vo-XP"};